document.querySelectorAll('.finishes li').forEach(item => {
    item.addEventListener('click', function() {
        let parent = item.parentElement;
        let bedId = parent.getAttribute('data-bed-id');
        setFinish(item, bedId);
    });
});

document.querySelectorAll('.colors li').forEach(item => {
    item.addEventListener('click', function() {
        let parent = item.parentElement;
        let bedId = parent.getAttribute('data-bed-id');
        setColor(item, bedId);
    });
});

document.querySelectorAll('.padding-colors li').forEach(item => {
    item.addEventListener('click', function() {
        let parent = item.parentElement;
        let bedId = parent.getAttribute('data-bed-id');
        setPaddingColor(item, bedId);
    });
});

function setFinish(item, bedId) {
    item.classList.add('active');
    let choiceContainer = document.getElementById('current-finish-' + bedId);
    choiceContainer.innerText = item.getAttribute('data-finish-name');
}

function setColor(item, bedId) {
    item.classList.add('active');
    let choiceContainer = document.getElementById('current-color-' + bedId);
    choiceContainer.innerText = item.getAttribute('data-color-name');
}

function setPaddingColor(item, bedId) {
    item.classList.add('active');
    let choiceContainer = document.getElementById('current-padding-color-' + bedId);
    choiceContainer.innerText = item.getAttribute('data-color-name');
}